// ** Components
import { SITE_FOOTER_DEFAULTS, SITE_FOOTER_DEFAULTS_TYPED } from '@/components/common/defaults';

// ** Types
import type { FooterSocialLink } from '@/types/layoutProps';
import type {
	MegaMenuLink,
	MenuViewProps,
	MegaMenuColumn,
	MegaMenuContactBlock
} from '@/components/common/MegaMenuOverlay/megaMenuView.types';

export const AP07_MEGA_MENU_MEMBER_LINKS: MegaMenuLink[] = [
	{ label: 'Mein Profil', href: '#' },
	{ label: 'Meine Veranstaltungen', href: '#' },
	{ label: 'Mein Ehrenamt', href: '#' },
	{ label: 'Meine Beratungen', href: '#' },
	{ label: 'Meine Favoriten', href: '#' },
	{ label: 'Meine Dokumente', href: '#' }
];

export const AP07_MEGA_MENU_COLUMNS: MegaMenuColumn[] = [
	{
		title: 'Verband',
		items: [
			{ label: 'Wer wir sind', href: '#' },
			{ label: 'Vorstand & Gremien', href: '#' },
			{ label: 'Fachgruppen', href: '#' },
			{ label: 'Innungen', href: '#' },
			{ label: 'Team', href: '#' },
			{ label: 'Zahlen / Daten / Fakten', href: '#' },
			{ label: 'Tischlerpartner', href: '#' }
		]
	},
	{
		title: 'Mitgliederservice',
		items: [
			{ label: 'Was wir bieten', href: '#' },
			{ label: 'Interessenvertretung', href: '#' },
			{ label: 'Einkaufsvorteile', href: '#' },
			{ label: 'Nachwuchswerbung', href: '#' },
			{ label: 'Mitglied werden', href: '#' }
		]
	},
	{
		title: 'Betriebsberatung',
		items: [
			{ label: 'Wo wir unterstützen', href: '#' },
			{ label: 'Innovation & Technologie', href: '#' },
			{ label: 'Unternehmensführung', href: '#' },
			{ label: 'Arbeits- und Tarifrecht', href: '#' },
			{ label: 'Gestaltung & Nachhaltigkeit', href: '#' },
			{ label: 'Arbeits- und Gesundheitsschutz', href: '#' }
		]
	},
	{
		title: 'Ausbildung',
		items: [
			{ label: 'Wie wir Zukunft gestalten', href: '#' },
			{ label: 'Campus', href: '#' },
			{ label: 'Prüfungen', href: '#' },
			{ label: 'Die Gute Form', href: '#' },
			{ label: 'TOP Ausbildungsbetrieb', href: '#' }
		]
	},
	{
		title: 'Presse & Medien',
		items: [
			{ label: 'Aktuelles', href: '#' },
			{ label: 'Perspektiven', href: '#' },
			{ label: 'Lauschwerkstatt', href: '#' }
		]
	},
	{
		title: 'Veranstaltungen',
		items: [{ label: 'Tagungen & Schulungen', href: '#' }]
	}
];

export const AP07_MEGA_MENU_CONTACT: MegaMenuContactBlock = {
	...SITE_FOOTER_DEFAULTS.contact,
	faqHref: '#'
};

export const AP07_MEGA_MENU_SOCIAL_LINKS: FooterSocialLink[] = SITE_FOOTER_DEFAULTS_TYPED.socialLinks;

/** Composite mock for the entire menu view, used as default prop in MegaMenuOverlay. */
export const AP07_MEGA_MENU_VIEW: MenuViewProps = {
	memberLinks: AP07_MEGA_MENU_MEMBER_LINKS,
	menuColumns: AP07_MEGA_MENU_COLUMNS,
	contact: AP07_MEGA_MENU_CONTACT,
	socialLinks: AP07_MEGA_MENU_SOCIAL_LINKS,
	showMemberLoginButton: true
};
